var _path;

var _excluded = ["title", "titleId"];

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }

function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }

import * as React from "react";

function SvgIcFilterNew(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.77429 11.5057C9.96318 11.7112 10.0669 11.9798 10.0669 12.2575V20.4428C10.0669 20.9354 10.6613 21.1855 11.0132 20.8391L13.2966 18.2224C13.6021 17.8558 13.7706 17.6743 13.7706 17.3113V12.2594C13.7706 11.9816 13.8762 11.7131 14.0632 11.5075L20.6152 4.39817C21.1059 3.86483 20.7281 3 20.0022 3H3.8353C3.10936 3 2.72973 3.86297 3.22233 4.39817L9.77429 11.5057Z",
    fill: "#737373"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcFilterNew);
export default __webpack_public_path__ + "static/media/ic-filter-new.12435886d34173fff7d3cf9010260176.svg";
export { ForwardRef as ReactComponent };